// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';
import { getErrorSelector } from '@tcp/core/src/utils/utils.extension';
import { UPDATE_PROFILE_REDUCER_KEY } from '../../../../../constants/reducer.constants';
import AddEditPersonalInfoConstants from '../AddEditPersonalInformation.constants';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
} from '../../../../../utils/labels/labelUtilty';
import AddEditPersonalInformationLabels, {
  ACCOUNT_PROFILE,
} from '../views/AddEditPersonalInformation.labels';

const getState = (state) => state[UPDATE_PROFILE_REDUCER_KEY];

export const getError = createSelector(getState, (state) => state && state.get('error'));

export const getSuccess = createSelector(getState, (state) => state && state.get('success'));

export const getIsEmployee = (state) => {
  const selector = formValueSelector(AddEditPersonalInfoConstants.ADD_PROFILE_INFORMATION_FORM);
  return selector(state, 'isEmployee');
};

export const getPersonalInfoErrorMessage = createSelector(getError, (state) => {
  const labels = getLabelFromCopyOrFromTranslation(
    ACCOUNT_PROFILE,
    AddEditPersonalInformationLabels
  );

  labels.lbl_profile_ERR_DBPOPULATE = getDynamicLabelValues(
    `${ACCOUNT_PROFILE}.lbl_profile_ERR_DBPOPULATE`
  );

  return getErrorSelector(state, labels, 'lbl_profile');
});
